import { render } from "./NormalNewsDetail.vue?vue&type=template&id=dd5919b8&scoped=true"
import script from "./NormalNewsDetail.vue?vue&type=script&lang=js"
export * from "./NormalNewsDetail.vue?vue&type=script&lang=js"

import "./NormalNewsDetail.vue?vue&type=style&index=0&id=dd5919b8&lang=scss&scoped=true"
import "./NormalNewsDetail.vue?vue&type=style&index=1&id=dd5919b8&lang=scss"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5919b8"]])

export default __exports__